import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";

import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import SearchField from "../../../components/SearchField";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";

import Logs from "../../../components/Logs";
import SwitchBar from "../../../components/Pages/SwitchBar";
import CustomizedTable from "../../../components/UI/CustomizedTable";

import { message } from "antd";
import DeletePop from "../../../constants/ErrorPermissionModal";
import {
  deleteCabinCatergoryData,
  getCabinCatergoryData,
  updateCabinCatergoryData,
} from "../../../utils/ApiCalls/CabinCategory";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { checkPermission } from "../../../utils/Validation/checkPermission";

const CabinCategory = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Cabin Category",
      route: "/website/masters/cabin-category",
    },
  ];
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState("listing");
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();

  const [sort, setSort] = useState("");
  const [order, setOrder] = useState("");

  
    
      const locationP = useLocation();
    
      const [page, setPage] = useState(
        () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
      );
      const [pageSize, setPageSize] = useState(
        () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
      );
      const [search, setSearch] = useState(
        () => new URLSearchParams(locationP.search).get("search") || ""
      );
    
      useEffect(() => {
        const params = new URLSearchParams(locationP.search);
        const pageParam = parseInt(params.get("page")) || 1;
        const pageSizeParam = parseInt(params.get("pageSize")) || 10;
        const searchParam = params.get("search") || "";
    
        // setPage(pageParam);
        // setPageSize(pageSizeParam);
        setSearch(searchParam);
      }, [locationP.search]);
    
      useEffect(() => {
        const params = new URLSearchParams();
        const currentParams = new URLSearchParams(locationP.search);
    
        params.set("page", page);
        params.set("pageSize", pageSize);
        if (search) params.set("search", search);
    
        if (currentParams.toString() !== params.toString()) {
          navigate({ search: params.toString() }, { replace: true });
        }
      }, [page, pageSize, search, navigate, locationP.search]);
    
  

  const sortHandler = async (options) => {
    if (Object.keys(options).length > 0) {
      let sort, order;
      sort = options.columnKey;
      order =
        options.order === "ascend"
          ? "asc"
          : options.order === "descend"
          ? "desc"
          : undefined;
      await getData(page, sort, order);
    }
  };

  const columns = [
    {
      title: "Sl",
      width: 30,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (position, record, index) =>((page - 1) * pageSize) + index + 1,
    },

    {
      title: "Display Name",
      dataIndex: "display_name",
      key: "display_name",
      sorter: (a, b) => "",
      width: 50,
    },

    {
      title: "Vessel",
      dataIndex: "vessel",
      key: "vessel",
      sorter: (a, b) => "",
      width: 50,
      render: (item) => <div>{item?.displayName}</div>,
    },

    {
      title: "Category Code",
      dataIndex: "category_code",
      key: "category_code",
      sorter: (a, b) => "",
      width: 50,
    },

    {
      title: "Action",
      key: "operation",
      width: 40,
      render: (text, record) => (
        <div className="table_action_btn">
          <button className="btn" onClick={() => handleEdit(record.id)}>
            <i className="ri-edit-2-line" data-toggle="tooltip" title="Edit"></i>
          </button>
          <DeletePop onConfirm={() => handleDelete(record.id)}>
            <div>
              {" "}
              <button className="btn delete_btn">
                <i
                  className="ri-delete-bin-line"
                  data-toggle="tooltip"
                  title="Delete"
                ></i>
              </button>
            </div>
          </DeletePop>
        </div>
      ),
    },
  ];
  useEffect(() => {
    getData(page);
  }, [page, pageSize, search]);

 
  const getData = async (value, sort, order) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let args = { search: search, page: value, limit: pageSize };
    if (order) {
      if (sort) {
        args = { ...args, sort };
      }
      args = { ...args, order };
    }

    let data = await getCabinCatergoryData(args);
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  const handleEdit = async (id) => {
    if (checkPermission(permission, "update_per", "Cabin Category",window?.location?.pathname)) {
      navigate("/website/masters/cabin-category/edit/" + id);
    } else {
      message.error("Update permission missing");
    }
  };
  const handleDelete = async (id) => {
    if (checkPermission(permission, "delete_per", "Cabin Category",window?.location?.pathname)) {
    await   deleteCabinCatergoryData(id);
      getData();
    } else {
      message.error("Missing Permission for delete ");
    }
  };

  return (
    <Layout type={"read_per"} module_data={"Cabin Category"}>
      <CustomHeaderTitle title={"Cabin Category"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Cabin Category"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Cabin Category List", value: "listing" },
                { value: "logs", title: " History Logs" },
              ]}
              activeTab={active}
              setActiveTab={setActive}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Cabin Category List</h5>
                  <Link to="/website/masters/cabin-category/add" className="btn add_v_btn">
                    Add Cabin Category
                  </Link>
                </div>
                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div style={{ maxWidth: 200 }}>
                        <SearchField
                          value={search}
                          SearchValue={() => {
                            setPage(page);
                          }}
                          setValue={(e) => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    {rows && (
                      <CustomizedTable
                        setRows={setRows}
                        setPageSize={setPageSize}
                        setPage={setPage}
                        pageSize={pageSize}
                        page={page}
                        count={count}
                        columns={columns}
                        rows={rows}
                        title={"Cabin Category"}
                        sortHandler={sortHandler}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {active === "logs" && (
          <Logs
            type={"CabinCategory"}
            slug={"/website/masters/cabin-category/edit/"}
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};

export default CabinCategory;
